import * as React from 'react';
import cn from 'classnames';

import { AppLoadSpinnerCenteredPosition } from 'shared/newEntities/components/AppLoadSpinner';
import {
  LoaderSpinnerColor,
  LoaderSpinnerSize
} from 'shared/newEntities/components/LoaderSpinner';

import LoaderSpinner from '../animations/LoaderSpinner';

import './AppLoadSpinner.modules.scss';

type Props = {
  color?: LoaderSpinnerColor;
  size?: LoaderSpinnerSize;
  /** Только при `centeredPosition === none`: центрирование через проп `LoaderSpinner`. */
  centered?: boolean;
  centeredPosition?: AppLoadSpinnerCenteredPosition;
};

const AppLoadSpinner: React.FC<Props> = ({
  color = LoaderSpinnerColor.blue,
  size = LoaderSpinnerSize.md,
  centered = false,
  centeredPosition = AppLoadSpinnerCenteredPosition.none
}) => {
  const screenOverlay =
    centeredPosition === AppLoadSpinnerCenteredPosition.screen;
  const containerOverlay =
    centeredPosition === AppLoadSpinnerCenteredPosition.container;
  const overlay = screenOverlay || containerOverlay;

  return (
    <div
      styleName={cn(
        'app-load-spinner',
        screenOverlay && 'app-load-spinner_overlay-screen',
        containerOverlay && 'app-load-spinner_overlay-container'
      )}
    >
      <LoaderSpinner
        color={color}
        centered={!overlay && centered}
        size={size}
      />
    </div>
  );
};

export default React.memo(AppLoadSpinner);
